<template>
  <div id="yagiprime_adlp" class="yagiprime_adlp_rirekisho" v-once>

    <div class="mv">
      <div class="prime_deco">
        <div class="wrapper">
          <h2 class="h2">
            <span class="h2_small">今流行りの</span><br>
            <span class="h2_big">AI</span>を使った<br>
            履歴書はどう？
          </h2>
          <p class="mv_lead">
            いつも1時間かかる志望動機が、<br>
            1分でできたらコスパ最強！<br>
            今すぐ最新のAIを使ってみよう！
          </p>
          <div class="cv_block">
            <a href="/format/rirekisho_ai_career" class="cv_link">AI履歴書を作成する</a>
          </div>
        </div>
      </div>
    </div>

    <!--提案-->
    <div class="second">
      <div class="wrapper">
        <h3 class="h3">あなたにピッタリの<br>ヤギプライムの使い方をご紹介</h3>
        <ul class="renew2_flex merit_list">
          <li class="merit_item">
            <p class="item_top">文章作成が苦手...</p>
            <p class="item_bottom">AIヤギに履歴書をもとに、<br class="sp">志望動機や自己PRを考えてもらおう！</p>
          </li>
          <li class="merit_item">
            <p class="item_top item_top02">面接で緊張する...</p>
            <p class="item_bottom">人前に出るのが苦手でも、<br class="sp">AIヤギ相手なら面接練習がサクッとできる！</p>
          </li>
          <li class="merit_item">
            <p class="item_top item_top03">仕事探しは面倒...</p>
            <p class="item_bottom">転職する気持ちがあれば十分！<br class="sp">AIがお仕事をレコメンドしてくれる！</p>
          </li>
        </ul>
        <div class="cv_block">
          <p class="cv_lead">AIサービスを全て利用する</p>
          <a href="/format/rirekisho_ai_career" class="cv_link">まずはAI履歴書を作成する</a>
        </div>
      </div>
    </div>

    <!--特典-->
    <div class="third">
      <div class="wrapper">
        <h3 class="h3">うれしい特典一覧</h3>
        <div class="renew2_flex renew2_sp_flex special_list">
          <img src="/static/renew3_img/yagiprime_img/merit01.png" alt="AI志望動機" class="special_item">
          <img src="/static/renew3_img/yagiprime_img/merit02.png" alt="AI自己PR" class="special_item">
          <img src="/static/renew3_img/yagiprime_img/merit03.png" alt="AI面接練習" class="special_item">
          <img src="/static/renew3_img/yagiprime_img/merit04.png" alt="お仕事レコメンド" class="special_item">
          <img src="/static/renew3_img/yagiprime_img/merit05.png" alt="エージェント対応" class="special_item">
          <img src="/static/renew3_img/yagiprime_img/merit06.png" alt="メール便無料" class="special_item">
          <img src="/static/renew3_img/yagiprime_img/merit07.png" alt="フォント切り替え" class="special_item">
        </div>
        <p class="special_lead">ヤギプライムは、ヤギッシュの各種サービスを完全無料または一部無料で利用できるほか、面倒な仕事探しが不要になり、志望動機は生成AIで作成することが可能です。</p>
      </div>
      <div class="cv_block">
        <p class="cv_lead">少しでも気になる方は</p>
        <a href="/format/rirekisho_ai_career" class="cv_link">まずはAI履歴書を作成する</a>
      </div>
    </div>

  </div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style scoped>
#yagiprime_adlp .wrapper {
  width: 768px;
  margin: 0 auto;
}

#yagiprime_adlp .h3 {
  font-size: 18px;
  font-weight: bold;
  color: #004D40;
  text-align: center;
  margin-bottom: 30px;
}

/*ヘッダー*/

#yagiprime_adlp .n-header {
  justify-content: space-between;
  align-items: stretch;
  margin: 10px auto;
}

#yagiprime_adlp .h-logo-img {
  width: 100px;
  height: auto;
}

#yagiprime_adlp .cv-btn {
  background: #E3165C;
  color: #fff;
  padding: 5px 20px;
  border-radius: 50px;
  font-size: 14px;
}

#yagiprime_adlp .cv-btn:hover {
  opacity: 1;
  text-decoration: none;
  font-weight: bold;
}

#yagiprime_adlp .mv {
  padding: 50px 0;
  background: linear-gradient(90deg, #ACB6E5 0%, #86FDE8 100%);
}

#yagiprime_adlp .mv .wrapper {
  position: relative;
  z-index: 10;
}

#yagiprime_adlp .mv .wrapper::after {
  position: absolute;
  content: "";
  background-image: url(/static/renew3_img/yagiprime_img/yagiai.png);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 300px;
  height: 480px;
  right: 0;
  top: calc(50% - 240px);
}

#yagiprime_adlp .yagiprime_adlp_interview .mv .wrapper::after {
  background-image: url(/static/renew3_img/yagiprime_img/aiinterview.png);
  width: 400px;
  height: 250px;
  top: 279px;
  right: -150px;
}

#yagiprime_adlp .h2 {
  color: #004D40;
  font-size: 40px;
  font-weight: bold;
  font-family: "Noto Serif JP", serif;
  padding: 0;
  line-height: 1.25;
  margin-bottom: 30px;
  text-align: left;
}

#yagiprime_adlp .h2::before {
  display: none;
}

#yagiprime_adlp .h2_small {
  font-size: 24px;
  position: relative;
  top: 10px;
}

#yagiprime_adlp .h2_big {
  font-size: 68px;
}

#yagiprime_adlp .yagiprime_adlp_interview .h2 {
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, YuGothic, "\30D2\30E9\30AE\30CE\89D2\30B4 ProN W3", Hiragino Kaku Gothic ProN, Arial, "\30E1\30A4\30EA\30AA", Meiryo, MyFontFamily, Segoe UI Emoji, Segoe UI Symbol, Apple Color Emoji, Noto Color Emoji, Noto Emoji, sans-serif;
  text-align: center;
}

#yagiprime_adlp .mv_lead {
  color: #004D40;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 50px;
}

#yagiprime_adlp .yagiprime_adlp_interview .mv_lead {
  text-align: center;
}

#yagiprime_adlp .prime_deco {
  position: relative;
  z-index: 1;
  margin-bottom: -450px;
}

#yagiprime_adlp .prime_deco::after {
  position: relative;
  content: "";
  display: inline-block;
  background-image: url(/static/renew3_img/yagiprime_img/aiimg.png);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 450px;
  top: -450px;
  z-index: 1;
  opacity: 0.1;
}

#yagiprime_adlp .second {
  padding: 50px 0;
  margin-bottom: 50px;
  background: #EEF5E8;
}

#yagiprime_adlp .merit_list {
  justify-content: space-between;
  margin-bottom: 30px;
}

#yagiprime_adlp .merit_item {
  width: calc(100% / 3 - 10px);
}

#yagiprime_adlp .item_top {
  position: relative;
  background: #0F9934;
  border-radius: 10px 10px 0 0;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
  padding: 10px 20px;
}

#yagiprime_adlp .item_top::after {
  position: absolute;
  content: "";
  background-image: url(/static/renew3_img/yagiprime_img/merit01.svg);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 40px;
  height: 40px;
  right: 20px;
  top: 20px;
}

#yagiprime_adlp .item_top02::after {
  background-image: url(/static/renew3_img/yagiprime_img/merit02.svg);
}

#yagiprime_adlp .item_top03::after {
  background-image: url(/static/renew3_img/yagiprime_img/merit03.svg);
}

#yagiprime_adlp .item_bottom {
  background: #fff;
  color: #004D40;
  font-size: 14px;
  font-weight: bold;
  border-radius: 0 0 10px 10px;
  padding: 10px 20px;
}

#yagiprime_adlp .cv_block {
  text-align: center;
  font-weight: bold;
}

#yagiprime_adlp .cv_lead {
  position: relative;
  display: inline-block;
  font-size: 14px;
  color: #004D40;
}

#yagiprime_adlp .cv_lead::before,
#yagiprime_adlp .cv_lead::after {
  content: '';
  position: absolute;
  top: 50%;
  display: inline-block;
  width: 22px;
  height: 2px;
  background-color: #004D40;
  -webkit-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#yagiprime_adlp .cv_lead::before {
  left: -30px;
  -webkit-transform: rotate(60deg);
  transform: rotate(60deg);
}

#yagiprime_adlp .cv_lead::after {
  right: -30px;
}

#yagiprime_adlp .cv_link {
  position: relative;
  display: block;
  background: #004D40;
  border-radius: 50px;
  color: #fff;
  font-weight: bold;
  width: 280px;
  padding: 12px 0;
  margin: 0 auto;
  transition-duration: .4s;
  z-index: 5;
}

#yagiprime_adlp .cv_link::after {
  content: "";
  width: 10px;
  height: 10px;
  border: 0;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  position: absolute;
  top: 0;
  right: 20px;
  bottom: 0;
  margin: auto;
}

#yagiprime_adlp .cv_link:hover {
  transform: scale(1.1);
  opacity: 1;
  text-decoration: none;
}

#yagiprime_adlp .third {
  margin-bottom: 50px;
}

#yagiprime_adlp .special_list {
  justify-content: center;
  flex-wrap: wrap;
  width: 80%;
  margin: 0 auto 30px;
}

#yagiprime_adlp .special_item {
  width: calc(100% / 5);
  margin-bottom: 10px;
  margin-right: 10px;
}

#yagiprime_adlp .special_lead {
  font-size: 14px;
  margin-bottom: 50px;
}

#yagiprime_adlp .third .cv_block {
  background: linear-gradient(90deg, #ACB6E5 0%, #86FDE8 100%);
  padding: 50px 0;
}

#yagiprime_adlp .footer_link {
  justify-content: center;
  flex-wrap: wrap;
  font-size: 14px;
  margin-bottom: 50px;
}

#yagiprime_adlp .footer_item {
  position: relative;
  margin-right: 20px;
}

#yagiprime_adlp .footer_item::after {
  position: absolute;
  content: "|";
  right: -10px;
}

#yagiprime_adlp .footer_item_last:after {
  display: none;
}

#yagiprime_adlp .copyright {
  color: #004D40;
  text-align: center;
  font-size: 12px;
}

@media screen and (max-width: 640px) {

  #yagiprime_adlp .wrapper {
    width: 100%;
    padding: 0 10px;
  }

  #yagiprime_adlp .h2 {
    font-size: 2.5rem;
    text-align: left;
  }

  #yagiprime_adlp .h2_small {
    font-size: 20px;
  }

  #yagiprime_adlp .mv_lead {
    font-size: 16px;
  }

  #yagiprime_adlp .mv .wrapper::after {
    width: 130px;
    height: 300px;
    right: 10px;
    top: 100px;
  }

  #yagiprime_adlp .yagiprime_adlp_interview .h2 {
    position: relative;
    top: -30px;
    margin-bottom: 30px;
  }

  #yagiprime_adlp .yagiprime_adlp_interview .mv_lead {
    position: relative;
    top: -30px;
    margin-bottom: 100px;
    z-index: 10;
  }

  #yagiprime_adlp .yagiprime_adlp_interview .mv .wrapper::after {
    width: 274px;
    height: 155px;
    top: 258px;
    right: calc(50% - 132px);
    z-index: 5;
  }

  #yagiprime_adlp .merit_item {
    width: 100%;
    margin-bottom: 10px;
  }

  #yagiprime_adlp .item_bottom {
    padding: 20px;
  }

  #yagiprime_adlp .special_list {
    width: 100%;
    justify-content: space-between;
  }

  #yagiprime_adlp .special_item {
    width: calc(100% / 3 - 10px);
    margin-right: 0;
  }

}
</style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () { }
}
</script>
